import { FrPill } from "./FrPill";
import { SourceBadge, type DataSource } from "./SourceBadge";
import { useDataSources, isSynthetic } from "@/hooks/useDataSources";

interface SectionHeadingProps {
  title: string;
  frs?: string[];
  description?: string;
  /** Upstream system that produced this section's data. */
  source?: DataSource;
  /**
   * Force the synthetic flag. When omitted and a `source` is set, the
   * heading auto-detects synthetic data from /ops/data-sources so stub /
   * fallback panels are honestly labelled.
   */
  synthetic?: boolean;
}

export function SectionHeading({ title, frs, description, source, synthetic }: SectionHeadingProps) {
  const ds = useDataSources();
  const autoSynthetic = source ? isSynthetic(ds.data, source) : false;
  const showSynthetic = synthetic ?? autoSynthetic;
  return (
    <div className="flex flex-wrap items-baseline gap-x-3 gap-y-2">
      <h2 className="text-[11px] font-semibold uppercase tracking-[0.08em] text-fg-muted">
        {title}
      </h2>
      {frs && frs.length > 0 && (
        <div className="flex flex-wrap items-center gap-1.5">
          {frs.map((fr) => (
            <FrPill key={fr} label={fr} />
          ))}
        </div>
      )}
      {source && (
        <span className="flex items-center">
          <SourceBadge source={source} synthetic={showSynthetic} />
        </span>
      )}
      {description && (
        <p className="ml-auto max-w-[540px] text-right text-xs text-fg-faint">
          {description}
        </p>
      )}
    </div>
  );
}
